// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"395eedbd","842":"deb614bf"}[chunkId] + ".chunk.js";
};